import { useState, useEffect, forwardRef } from "react";
import { Table, Input } from 'reactstrap';
import ReactTooltip from "react-tooltip";
import Select from "./Select";
import Integer from "./Integer";
import sortObjectsArray from 'sort-objects-array';
import DateField from "./DateField";
import Decimal from "./Decimal";
import MultiSelect from "./MultiSelect";
import MultiSelectCreatable from "./MultiSelectCreatable";
import InputMask from 'react-input-mask';
import FileUploadS3 from "./FileUploadS3";
import { useDispatch } from 'react-redux';
import EmailInput from "./Email";
import Phone from "./Phone";
import sleep from 'sleep-promise';
import { v4 as uuid } from 'uuid';
import { useBasePath } from "../../../../../util/core/Path";
import { CheckBoxStylized } from "./CheckboxStylized";
import TimeField from "./TimeField";

const MultiInput = forwardRef((props, ref) => {
    const path = useBasePath();
    const dispatch = useDispatch();
    let [items, updateItems] = useState();
    let [form, updateForm] = useState();
    let [classTh, setClassTh] = useState('');

    useEffect(() => {
        updateForm(props.form ? props.form : {});
        if (props.value) {
            let value = sortObjectsArray(props.value, 'index');
            if (value.length === 1 || path == props.paths.pathView) {
                value = verifyObject(value);
            }
            updateItems(value);
        } else {
            let tempItem = {};
            let tempItems = [];
            props.form.forEach((element, index2) => {
                tempItem['id'] = uuid();
                tempItem['noValues'] = true;
                setClassTh(props.showDeleteButton ? '' : 'd-none');
                tempItem[element.name] = '';
            });
            tempItems.push(tempItem);
            updateItems(tempItems);
        }

    }, [props.showDeleteButton]);

    useEffect(() => {
        if (form && items.length > 0 && props.unique) {
            const selects = form.filter(f => f.type === 'select' && !!f.unique);

            selects.forEach((select) => {
                const name = select.name;
                const selectArray = items.map(item => item[name]).filter(item => item && item.value);
                const repeated = verifyRepeatedValues(selectArray);

                updateForm(prev => {
                    const data = prev.map(i => {
                        if (i.name === select.name) {
                            i.repeatedValue = repeated;
                        }

                        return i;
                    });

                    return data;
                });

            });
        };

        if (form && items.length > 0) {
            const orders = form.filter(f => f.type === 'order_label');
            orders.forEach((order) => {
                const name = order.name;
                items.forEach((element, index) => {
                    element[name] = index + 1;
                });
            });
        };

    }, [items]);

    const verifyRepeatedValues = (array) => {
        const values = new Set();

        for (const obj of array) {
            const value = obj.value;

            if (values.has(value)) {
                return value;
            }

            values.add(value);
        }

        return false;
    };

    const verifyObject = (arrayItems) => {
        arrayItems.forEach((objectArray, objectIndex) => {
            let keys = Object.keys(objectArray);
            if (keys.indexOf('id') !== -1) {
                keys.splice(keys.indexOf('id'), 1);
            }
            let countEmpty = 0;
            keys.forEach(key => {
                if (objectArray[key] == '' && key !== 'id') {
                    countEmpty++;
                }
            })

            arrayItems[objectIndex].noValues = (countEmpty == keys.length && arrayItems.length == 1) ? true : false;

            if ((countEmpty == keys.length && arrayItems.length == 1) || path == props.paths.pathView) {
                setClassTh(props.showDeleteButton ? '' : 'd-none');
            } else {
                if (arrayItems.length == 1) {
                    setClassTh(props.showDeleteButton ? '' : 'd-none');
                } else {
                    setClassTh('');
                }
            }
        })

        return arrayItems;
    }

    const onUpload = async (inputName, file, index) => {
        let tempItems = items;
        tempItems[index][inputName] = file;
        setTimeout(() => {
            updateItems(tempItems);
            dispatch({ type: 'SHOW_LOADING', value: false });
        }, 100);
    };

    const beforeUpload = element => {
        dispatch({ type: 'SHOW_LOADING', value: true });
    };

    const deleteUpload = async (inputName, element, index) => {
        let tempItems = items;
        tempItems[index][inputName] = '';
        setTimeout(() => {
            updateItems(tempItems);
            dispatch({ type: 'SHOW_LOADING', value: false });
        }, 100);
    };

    const handleChange = async (event, item, index, input) => {
        let tempItems = [];

        items.forEach((element, index2) => {
            if (index == index2) {
                switch (input.type) {
                    case 'select':
                        element[input.name] = {
                            label: event.target.label,
                            value: event.target.value
                        };
                        break;
                    case 'phone':
                        element[input.name] = event.target.value.replace(/[^0-9]/g, '');
                        break;
                    case 'checkboxStylized':
                        element[input.name] = event.target.checked;
                        break;
                    default:
                        element[input.name] = event.target.value;
                        break;
                }

            }
            tempItems.push(element);
        });

        if (event.target.value != '' && props.sortBy == input.name) {
            tempItems = sortObjectsArray(tempItems, props.sortBy);
            updateItems([]);
            await setTimeout(() => {
                updateItems(tempItems);
            }, 100)
        } else {
            updateItems(tempItems);
        }

        props.onChange({
            target: {
                name: props.name,
                value: items
            }
        });
    };

    const clickAdd = () => {
        let tempItem = {};
        let tempItems = [];

        items.forEach((element, index) => {
            tempItems.push(element);
        });

        form.forEach((element, index) => {
            tempItem['id'] = uuid();
            tempItem[element.name] = '';
        });
        tempItems.push(tempItem);
        tempItems = verifyObject(tempItems);
        updateItems(tempItems);

        props.onAdd({
            target: {
                name: props.name,
                value: tempItems
            }
        });
    }

    const onDelete = async index => {

        let tempItems = [];

        items.forEach((element, index2) => {
            if (index2 != index) {
                tempItems.push(element);
            }
        });

        updateItems([]);
        await sleep(100);

        if (tempItems.length > 0) {
            tempItems = verifyObject(tempItems);
            updateItems(tempItems);
        } else {
            updateItems([]);
        }

        props.onDelete({
            target: {
                name: props.name,
                value: tempItems
            }
        });
        //}
    }

    return (
        <div ref={ref}>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {form && form.map(item => {
                            return (
                                <th style={item.styleTh}>
                                    {item.label}
                                    {item.validations?.required && <span style={{ color: 'red' }}> *</span>}
                                </th>
                            )
                        })
                        }
                        <th className={classTh}>
                            {(!props.readOnly) && (
                                <span>Excluir</span>
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items && items.map((element, index) => {
                        return (
                            <tr key={index}>
                                {form && form.map(item => {
                                    switch (item.type) {
                                        case 'text':
                                            const isStringInvalid = item?.validations?.required && items[index][item.name]?.length === 0;
                                            return (
                                                <td>
                                                    <Input
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        value={items[index][item.name]}
                                                        type='text'
                                                        name={item.name}
                                                        maxLength={item.maxLength ? item.maxLength : 20}
                                                        readOnly={props.readOnly}
                                                        required={props.required}
                                                        className={isStringInvalid && 'is-invalid'}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'select':
                                            const isUniqueValue = props.unique && items[index][item.name] && item?.repeatedValue === items[index][item.name].value ? 'Selecione esse valor apenas uma vez' : false;
                                            const isSelectInvalid = (item?.validations?.required && !items[index][item.name]?.value)
                                            return (
                                                <td>
                                                    <Select
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        options={item.options}
                                                        optionsEndpoint={item.optionsEndpoint}
                                                        disabled={props.readOnly}
                                                        isClearable={item.isClearable ? item.isClearable : true}
                                                        error={isSelectInvalid || isUniqueValue}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'checkboxStylized':
                                            return (
                                                <td className="d-flex" style={{ justifyContent: 'center' }}>
                                                    <CheckBoxStylized
                                                        name={item.name}
                                                        checked={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        disabled={props.readOnly}
                                                    />
                                                </td>
                                            );
                                            break;
                                        case 'multiselect':
                                            const isMultiSelectInvalid = item?.validations?.required && items[index][item.name]?.length === 0;
                                            return (
                                                <td>
                                                    <MultiSelect
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        options={item.options}
                                                        optionsEndpoint={item.optionsEndpoint}
                                                        disabled={props.readOnly}
                                                        error={isMultiSelectInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'multiselectCreatable':
                                            const multiSelectValue = items[index][item.name];

                                            const isMultiSelectCreatableInvalid = item?.validations?.required && multiSelectValue.length === 0;
                                            return (
                                                <td>
                                                    <MultiSelectCreatable
                                                        name={item.name}
                                                        value={multiSelectValue}
                                                        creatable={item.creatable}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        options={item.options}
                                                        optionsEndpoint={item.optionsEndpoint}
                                                        disabled={props.readOnly}
                                                        error={isMultiSelectCreatableInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'integer':
                                            const isIntInvalid = item?.validations?.required && items[index][item.name]?.length === 0;
                                            return (
                                                <td>
                                                    <Integer
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        maxLength={item.maxLength ? item.maxLength : 20}
                                                        readOnly={props.readOnly}
                                                        error={isIntInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'date':
                                            const isDateInvalid = item?.validations?.required && items[index][item.name]?.length === 0 || items[index][item.name] === null;
                                            return (
                                                <td>
                                                    <DateField
                                                        name={item.name}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        value={items[index][item.name]}
                                                        options={item.options}
                                                        readOnly={props.readOnly}
                                                        error={isDateInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'decimal':
                                            const decimalValue = items[index][item.name] || '';
                                            const isDecimalInvalid = item?.validations?.required && decimalValue.length === 0;
                                            return (
                                                <td>
                                                    <Decimal
                                                        type="text"
                                                        name={item.name}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        value={decimalValue}
                                                        maxLength={item.maxLength ? item.maxLength : 100}
                                                        readOnly={props.readOnly}
                                                        autoFocus={item.autoFocus}
                                                        error={isDecimalInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'phone':
                                            const phoneValue = items[index][item.name] || '';
                                            const isPhoneInvalid = item?.validations?.required && phoneValue?.length === 0;
                                            return (
                                                <td>
                                                    <Phone
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        readOnly={props.readOnly}
                                                        autoFocus={item.autoFocus}
                                                        error={isPhoneInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'fileS3':
                                            const isFileInvalid = item?.validations?.required && items[index][item.name]?.length === 0;
                                            return (
                                                <td>
                                                    <FileUploadS3
                                                        name={item.name}
                                                        path={item.uploadPath}
                                                        file={items[index][item.name]}
                                                        onUpload={(inputName, file) => { onUpload(inputName, file, index) }}
                                                        onRemove={(inputName, element) => { deleteUpload(inputName, element, index) }}
                                                        beforeUpload={element => { beforeUpload(element) }}
                                                        accept={item.extensionAccept}
                                                        titleButton={item.titleButton}
                                                        limitFileSize={item.limitFileSize}
                                                        disabled={item.readOnly ? true : false}
                                                        style={{ margin: 0 }}
                                                        error={isFileInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'email':
                                            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                                            const isEmailInvalid = item?.validations?.required && items[index][item.name]?.length === 0 || emailRegex.test(items[index][item.name]);
                                            return (
                                                <td>
                                                    <EmailInput
                                                        onChange={(event) => handleChange(event, element, index, item)}
                                                        value={items[index][item.name]}
                                                        type='text'
                                                        name={item.name}
                                                        maxLength={item.maxLength ? item.maxLength : 20}
                                                        readOnly={props.readOnly}
                                                        error={isEmailInvalid}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'order_label':
                                            return (
                                                <td>
                                                    <Input
                                                        value={items[index][item.name]}
                                                        type='text'
                                                        name={item.name}
                                                        readOnly
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'time':
                                            const isTimeInvalid = item?.validations?.required && items[index][item.name]?.length === 0 || items[index][item.name] === null;
                                            return (
                                                <td>
                                                    <TimeField
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={(event) => handleChange(event, element, index, item)}
                                                        options={item.options}
                                                        readOnly={props.readOnly}
                                                        error={isTimeInvalid}
                                                    />
                                                </td>
                                            )
                                            break

                                    }

                                })
                                }
                                <td style={{ width: '5%' }} className={classTh}>
                                    {(!props.readOnly) && (
                                        <div className="d-flex justify-content-center">
                                            <a
                                                className="btn btn-danger btn-sm btn-action"
                                                onClick={() => { onDelete(index) }}
                                                data-tip data-for={"tooltip-delete-" + index}
                                                data-testid={`excluir-${index}`}
                                            >
                                                <i className="fas fa-trash">
                                                </i>
                                            </a>
                                            <ReactTooltip id={"tooltip-delete-" + index} place="top" effect="solid">
                                                Excluir
                                            </ReactTooltip>
                                        </div>
                                    )}

                                </td>
                            </tr>
                        )

                    })}
                </tbody>
            </Table>
            {props.error && (
                <div
                    className="error invalid-feedback"
                    style={{ display: 'inline', width: '100%', marginLeft: '10px' }}
                >
                    {props.error}
                </div>
            )}
            {!props.readOnly && (
                props.limit ? (
                    items?.length < props.limit && (
                        <div className="d-flex justify-content-center">
                            <button onClick={clickAdd} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                Adicionar
                            </button>
                        </div>
                    )
                ) : (
                    <div className="d-flex justify-content-center">
                        <button onClick={clickAdd} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                            Adicionar
                        </button>
                    </div>
                )
            )}
        </div>

    );
})
export default MultiInput;